import api from '@/api';

const state = {
	countries: [],
	turkeyLocations: [],
	updated: 0,
};

const getters = {};

const actions = {
	getTurkeyLocations: ({ commit }, { refresh = false, updateStore = false, ...params }) => {
		return new Promise((resolve, reject) => {
			const { updated } = state;
			if (!refresh && !updateStore && updated > 0) {
				resolve({ data: { items: state.turkeyLocations } });
				return;
			}

			api.geolocations
				.getTurkeyLocations(params)
				.then(response => {
					const { items } = response.data;
					if (updateStore) {
						commit('setTurkeyLocations', { items });
					}
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	getCountries: ({ commit }, { refresh = false, updateStore = false, ...params }) => {
		return new Promise((resolve, reject) => {
			const { updated } = state;
			if (!refresh && !updateStore && updated > 0) {
				resolve({ data: { items: state.countries } });
				return;
			}

			api.geolocations.getCountries(params)
				.then(response => {
					const { items } = response.data;
					if (updateStore) {
						commit('setCountries', { items });
					}
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
};

const mutations = {
	setTurkeyLocations: (state, { items }) => {
		const now = new Date();
		state.turkeyLocations = items;
		state.updated = now.getTime();
	},
	setCountries: (state, { items }) => {
		const now = new Date();
		state.countries = items;
		state.updated = now.getTime();
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}; 